import { render, staticRenderFns } from "./insLogin.vue?vue&type=template&id=806e900c&"
import script from "./insLogin.vue?vue&type=script&lang=js&"
export * from "./insLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports